import { Injectable } from '@angular/core';
import {DatePipe} from "@angular/common";
import {Apollo} from "apollo-angular";
import {get_company_event_dates, get_company_event_types} from "../graphql/getCompanyEvents";
import moment from "moment";
import {create_new_company_event, create_new_company_event_datetime} from "../graphql/createCompanyEvent";
import {DateTimeService} from "../../services/date-time.service";
import {update_date_time} from "../graphql/updateCompanyEvent";
import {OutlookEventService} from "../../services/outlook-event.service";

@Injectable({
  providedIn: 'root',
})
export class CompanyEventCalendarManagerService {
  public companyEventTypes: { [key: string]: any } = {
    'CREAFoundation': {
      color: 'var(--purple-3)',
      label: 'CREAFoundation',
    },
    'Internal CREA Event': {
      color: 'var(--medium-blue-3)',
      label: 'Internal CREA Event',
    },
    'Property Event': {
      color: 'var(--teal-2)',
      label: 'Property Event',
    },
    'Conference': {
      color: 'var(--amber-4)',
      label: 'Conference',
    },
    'Special Event': {
      color: 'var(--orange-3)',
      label: 'Special Event',
    },
    'Non-attended Event': {
      color: 'var(--cool-gray-5)',
      label: 'Non-attended Event'
    }

  };



  public eventStyling:any = (eventType:string) => {
    return {
      textColor: "black",
      backgroundColor: this.companyEventTypes[eventType].color,
      borderColor: this.companyEventTypes[eventType].color,
      groupId: this.companyEventTypes[eventType].groupId
    }

  }

  constructor(private datePipe: DatePipe, private apollo: Apollo, private dateTime: DateTimeService, private outlookService: OutlookEventService) {
    let keys = this.typesList();
    for(let i = 0; i < keys.length; i++){
      this.companyEventTypes[keys[i]].display = 'block';
      this.companyEventTypes[keys[i]].groupId = i.toString();
      this.companyEventTypes[keys[i]].checked = true;
      this.companyEventTypes[keys[i]].groupColor = this.companyEventTypes[keys[i]].color;
    }
  }

  public typesList(): string[] {
    return Object.keys(this.companyEventTypes);
  }

  toggleEventDisplay(key: string): string {
    if (this.companyEventTypes[key].display === 'none') {
      this.companyEventTypes[key].display = 'block';
      this.companyEventTypes[key].checked = true;
    } else {
      this.companyEventTypes[key].display = 'none';
      this.companyEventTypes[key].checked = false;
    }
    return this.companyEventTypes[key].display;
  }

  getColorClass(key: string): string {
    let color = this.companyEventTypes[key].color;
    return (
      'checkbox-' + color.substring(color.indexOf('-') + 2, color.indexOf(')'))
    );
  }

  companyEventMutation(formData:any, subscription: (data:any) => any){
    this.apollo.mutate({
      mutation: create_new_company_event,
      variables: {
        title: formData.name,
        company_event_type_id: formData.type,
        is_sponsored: formData.is_sponsored,
        cosponsor: formData.cosponsor,
        is_cosponsored: formData.is_cosponsored,
        sponsorship_amount: formData.sponsorship_amount
      }
    }).subscribe(({data}) => subscription(data));

  }

  companyEventDateTimeMutation(formData:any, company_event_id: string, calendarData: any, subcription: (data:any) => any, queryDates?: any, isPostponeTime?: boolean){
    let start = new Date(formData.startDate)
    let end = new Date(formData.endDate ? formData.endDate : formData.startDate)
    let startTime = null
    let endTime = null
    if(formData.startTime){
      start.setHours(formData.startTime.split(":")[0])
      start.setMinutes(formData.startTime.split(":")[1])
      startTime = isPostponeTime ? this.datePipe.transform(start, "HH:mm:ss",) : this.dateTime.convertTimezoneToUTC(start, formData.timezone)
    }
    if(formData.endTime){
      end.setHours(formData.endTime.split(":")[0])
      end.setMinutes(formData.endTime.split(":")[1])
      endTime = isPostponeTime ? this.datePipe.transform(end, "HH:mm:ss",) : this.dateTime.convertTimezoneToUTC(end, formData.timezone)
    }

    this.apollo.mutate({
      mutation: create_new_company_event_datetime,
      variables: {
        company_event_id: company_event_id,
        start_date: this.datePipe.transform(formData.startDate, 'yyyy-MM-dd', ),
        end_date: formData.endDate !== null ? this.datePipe.transform(formData.endDate, 'yyyy-MM-dd', ) : this.datePipe.transform(formData.startDate, 'yyyy-MM-dd'),
        start_time: startTime,
        end_time: endTime,
        timezone: formData.timezone,
        initial_date_time: 1
      },
      refetchQueries: queryDates == null ? [] : [{
        query: get_company_event_dates,
        variables: {start: queryDates.start, end: queryDates.end},
      }],
      awaitRefetchQueries: queryDates!==null,
    }).subscribe(({data}) => {
      let response:any = data;
      let dates = this.dateTime.formatCompanyEventTimes(response.createCompanyEventDate)
      this.createNewOutlookEvent(company_event_id, calendarData, dates, [])
      subcription(data)
    })
  }

  updateCompanyEventDateTime(data:any, subscription: (data:any) => any){
    this.apollo.mutate({
      mutation: update_date_time,
      variables: {
        event_date_id: data.event_date_id,
        start_date: this.datePipe.transform(data.startDate, 'yyyy-MM-dd'),
        end_date: this.datePipe.transform(data.endDate !== null ? data.endDate : data.startDate, 'yyyy-MM-dd'),
        start_time: data.startTime,
        end_time: data.endTime,
        timezone: data.timezone,
        initial_date_time: data.initial_date_time
      }
    }).subscribe((data:any) => subscription(data))
  }

  createNewOutlookEvent(id:string, calendar:any, dates:any, attendees: any[]){
    let outlookPayload = {
      "event_type_id": calendar.outlookType.id,
      "company_event_id": id,
      "attendees": [...attendees],
      "event_datetime": dates,
      "outlook_calendar_id" : calendar.outlookCalendar.id,
      "calendar": calendar.outlookCalendar.calendar_id,
      "user": calendar.outlookCalendar.user_id
    }

    this.outlookService.createOutlookEvent(outlookPayload, (data) => {});
  }


}
